module.exports = __webpack_public_path__ + "assets/GoldZeta.6e7dfcc93c112e3e5e3ef2681b26a8a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldZeta.png
// module id = 779
// module chunks = 0